import React, { useEffect, useRef, useState } from "react";
import {useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  viewBundleDetailController,
} from "../../services/bundleServices/bundleController";
import Dropdown from "react-bootstrap/Dropdown";
import { sellerListController } from "../../services/sellerServices/sellerServices";

const ViewBundle = () => {
  const [inputFieldValue, setInputFieldValue] = useState({});
  const [addProductList, setAddProductList] = useState([]);
    const [sellerList, setSellerList] = useState([]);
  const [multipleproductImage, setMultipleProductImage] = useState([]);
  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const uploadProductImage = useRef();
  const [search, setSearch] = useState("");
  const [cloneProductList, setCloneProductList] = useState([]);
  const role = localStorage.getItem("role");
  const isAdmin = role === "admin" ? true : false;

  const { id } = useParams();

  const viewBundleDetails = async () => {
    try {
      const response = await viewBundleDetailController(id);
      if (response?.data?.code === 200) {
        setInputFieldValue(response?.data?.data);
        setImages(response?.data?.data?.bundleImages);
        setAddProductList((prevList) => [
          ...prevList,
          ...response?.data?.data?.bundleProducts.map(
            ({ productDetails, qty }) => ({
              productId: productDetails?.id, // Corrected property name
              qty: qty,
              productName: productDetails?.productName,
            })
          ),
        ]);
        setCloneProductList((prevList) => [
          ...prevList,
          ...response?.data?.data?.bundleProducts.map(
            ({ productDetails, qty }) => ({
              productId: productDetails?.id, // Corrected property name
              qty: qty,
              productName: productDetails?.productName,
            })
          ),
        ]);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    viewBundleDetails();
  }, []);

  useEffect(() => {
    setCloneProductList(
      addProductList.filter(({ productName }) =>
        productName.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search]);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h2 className="page-title">
              <span
                className="page-title-icon bg-gradient-primary text-white me-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <i className="mdi mdi-chevron-double-left"></i>
              </span>
              View Bundle
            </h2>
            <nav aria-label="breadcrumb"></nav>
          </div>
          <div className="wrap_Add_retailer">
            <div className="col-12">
              <div className="card cstm_card_height">
                <div className="card-body">
                  <form className="form-sample">
                    <div className="row">
                      <div className="col-md-7">
                      {isAdmin && (
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">
                              Seller Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-8 text-start">
                              <select
                                type="text"
                                className="form-control"
                                name="sellerId"
                                placeholder="Select Seller"
                                value={inputFieldValue.sellerId}
                                disabled
                              >
                                <option value={0 || ""}>Select Seller</option>
                                {sellerList &&
                                  sellerList.map(
                                    ({ id, sellerName }, index) => {
                                      return (
                                        <option key={index} value={id}>
                                          {sellerName}
                                        </option>
                                      );
                                    }
                                  )}
                              </select>
                              <span style={{ color: "red" }} className="error">
                                {errors.sellerId}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">
                            Bundle Name
                          </label>
                          <div className="col-sm-8 text-start">
                            <input
                              disabled
                              type="text"
                              maxLength={25}
                              className="form-control"
                              placeholder="Enter Bundle Name"
                              name="bundleName"
                              value={inputFieldValue.bundleName}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.bundleName}
                            </span>
                          </div>
                        </div>
                        <div className="form-group row">
                        <label className="col-sm-4 col-form-label">
                          SKU <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8 text-start">
                        <input
                              type="text"
                              maxLength={50}
                              className="form-control"
                              placeholder="SKU"
                              name="sku"
                              value={inputFieldValue.sku || ""}
                              disabled
                            />
                          <span style={{ color: "red" }} className="error">
                            {errors.sku}
                          </span>
                        </div>
                      </div>

                        <div className="form-group row cstm_drop_styling">
                          <label className="col-sm-4 col-form-label">
                            Select Products
                          </label>
                          <div className="col-sm-8 text-start">
                            <Dropdown className="w-100" autoClose="outside">
                              <Dropdown.Toggle id="dropdown-autoclose-outside">
                                Select Products
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="cstm_styling_drop_set">
                                <input
                                  placeholder="search product"
                                  className="form-control"
                                  value={search}
                                  name="search"
                                  onChange={(e) => setSearch(e.target.value)}
                                />
                                {cloneProductList && cloneProductList.length > 0
                                  ? cloneProductList.map(
                                      ({ productName, id, qty }, index) => {
                                        return (
                                          <div
                                            className="cstm_flex_style"
                                            key={++index}
                                          >
                                            <Dropdown.Item href="#">
                                              {productName}
                                            </Dropdown.Item>
                                            <td>
                                              <div className="action_button_wrap">
                                                <div className="switch_button">
                                                  <p className="cstm_p_count">
                                                    {qty}
                                                  </p>
                                                </div>
                                              </div>
                                            </td>
                                          </div>
                                        );
                                      }
                                    )
                                  : null}
                              </Dropdown.Menu>
                              <span
                                style={{ color: "red", display: "block" }}
                                className="error text-start ml-4"
                              >
                                {errors.productIds}
                              </span>
                            </Dropdown>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">
                            Bundle Price
                          </label>
                          <div className="col-sm-8 text-start">
                            <input
                              type="text"
                              disabled
                              maxLength={25}
                              placeholder="Enter Bundle Price"
                              className="form-control"
                              name="bundlePrice"
                              value={inputFieldValue.bundlePrice}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.bundlePrice}
                            </span>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">
                            Discounted Price
                          </label>
                          <div className="col-sm-8 text-start">
                            <input
                              type="text"
                              disabled
                              className="form-control"
                              maxLength={10}
                              name="discountPrice"
                              placeholder="Enter Discount Price"
                              value={inputFieldValue.discountPrice}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">
                            Product Image
                          </label>
                          <div className="col-sm-8 text-start">
                            <input
                              ref={uploadProductImage}
                              disabled
                              type="file"
                              name="bundleImage"
                              accept="image/*"
                              className="form-control file-upload-info"
                              hidden
                              placeholder="Upload Image"
                            />

                            <span className="input-group-append cstm_append_group">
                              <button
                                className="file-upload-browse btn btn-gradient-primary"
                                type="button"
                                onClick={() =>
                                  uploadProductImage.current?.click()
                                }
                              >
                                Upload
                              </button>
                            </span>
                            <span
                              style={{ color: "red", display: "block" }}
                              className="error cstm_ere"
                            >
                              {errors.productImage}
                            </span>
                          </div>
                        </div>

                        <div className="mb-4 mt-4">
                          <div className="row">
                            {multipleproductImage?.length > 0
                              ? multipleproductImage?.map((image, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <div className="col-6 cstm_upload_image mb-3">
                                        <img
                                          src={URL.createObjectURL(image)}
                                          className="mb-2 mw-100 w-100 rounded"
                                          alt="banner"
                                          height="150px"
                                          width="200px"
                                        />
                                      </div>
                                    </React.Fragment>
                                  );
                                })
                              : null}
                          </div>

                          <div className="row">
                            {images &&
                              images.map(({ bundleImage, id }, index) => {
                                return (
                                  <React.Fragment key={++index}>
                                    <div className="col-6 cstm_upload_image mb-3">
                                      <img
                                        src={bundleImage}
                                        className="mb-2 mw-100 w-100 rounded"
                                        alt={""}
                                        height="150px"
                                        width="200px"
                                      />
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5">
                        {cloneProductList.length > 0 && (
                          <div>
                            <h6 className="mb-2">Selected Products</h6>
                            <div className="selected-products-list">
                              {cloneProductList.map((item) => {
                                return (
                                  <div
                                    key={item.id}
                                    className="d-flex justify-content-between align-items-center p-2 mb-2 border rounded"
                                  >
                                    <span>{item.productName}</span>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="mx-2">{item.qty}</span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewBundle;
